<template>
  <div class="prediction-wrapper">
    <div class="prediction-content flex flex-pack-justify">
      <div class="page-right">
        <div class="pred-title-box flex flex-align-center">
          <i class="pred-title-i"></i>
          <h3 class="pred-title">
            Match Predictions<i class="pred-title-why-m" @click="matchTipsIsShow()"></i>
            <span class="pred-title-tips-m">The model algorithm has selected {{ listDataPro['predTotal'] }} matches.</span>
          </h3>
          <i class="pred-title-why" @click="matchTipsIsShow()"></i>
          <span class="pred-title-tips">The model algorithm has selected {{ listDataPro['predTotal'] }} matches.</span>
          <router-link to="/prediction" @click.native="googleEventClick()" class="pred-title-more">More<i></i></router-link>
        </div>
        <PredictionList 
          :listDataPro="listDataPro" 
          :setting="setting"
          :svrTimestamp="svrTimestamp"
          ref="predListFn" 
        />
        <div class="pred-more-box">
          <router-link to="/prediction" @click.native="googleEventClick()" class="pred-more">More Predictions</router-link>
        </div>
      </div>
    </div>

    <van-popup v-model="macthTipsShow" class="van-popup-m"
      :closeable="false"
      :position="screenWidth>767?'center':'bottom'" 
      get-container="#app">
        <div class="intro-tips-box">
            <div class="intro-tips-top">
                <h4>Match Prediction Instructions</h4>
                <span class="intro-tips-close" @click="matchTipsIsShow()"></span>
            </div>
            <div class="intro-main">
                <div class="intro-dec">
                  <div class="intro-dec-title">
                    <i></i>
                    <p>For each match, we provide multiple prediction results for various types. After the match, if the selected option is correct, a green checkmark will be displayed. (Home team is on the left)</p>
                  </div>
                </div>
                <div class="intro-dec">
                  <div class="intro-dec-title">
                    <i></i>
                    <p>Each type is predicted by various algorithm models. Some types may have multiple prediction results from multiple models. Please select according to your preference.</p>
                  </div>
                </div>
                <div class="intro-dec">
                  <div class="intro-dec-title">
                    <i></i>
                    <p>To the right of each model name is displayed the record of this type in the league to which the match belongs, with each model and each type calculated separately.
                      As shown in the image, it means the hit rate is 89% in the last 30 matches.</p>
                  </div>
                  <div class="intro-dec-sub">
                    <p class="last-txt">LAST <span class="blue">15</span>   HIT <span class="red">89%</span></p>
                  </div>
                </div>
                <div class="intro-dec">
                  <div class="intro-dec-title">
                    <i></i>
                    <p>For leagues with excellent records, we have highlighted their names (as shown in the image), and you can click to filter them out.</p>
                  </div>
                  <div class="intro-dec-sub">
                    <div class="intro-img"><img src="~@/assets/images/match-intro-img.png" /></div>
                  </div>
                </div>

                <div class="intro-play-box">
                  <div class="intro-play-item">
                    <div class="intro-play-img" v-if="screenWidth > 767"><img src="~@/assets/images/play-intro-img-1.png" /></div>
                    <div class="intro-play-img" v-if="screenWidth <= 767"><img src="~@/assets/images/play-intro-img-m-1.png" /></div>
                    <div class="intro-play-info">
                      <h4>1x2 Result Prediction:</h4>
                      <p>Displays the predicted result of a full-time match. If the result is a draw, "Draw" will be shown.<br/>The first line shows the name of the prediction algorithm, the second line shows the predicted result, and the third line shows the record of the algorithm in the league where the match is being played.</p>
                    </div>
                  </div>
                  <div class="intro-play-item marginTop10">
                    <div class="intro-play-img" v-if="screenWidth > 767"><img src="~@/assets/images/play-intro-img-2.png" /></div>
                    <div class="intro-play-info">
                      <div class="intro-play-img" v-if="screenWidth <= 767"><img src="~@/assets/images/play-intro-img-m-2.png" /></div>
                      <h4>Asian Handicap Result Prediction:</h4>
                      <p>Displays the result of a full-time match with reference to the Asian handicap.</p>
                      <div class="intro-play-img" v-if="screenWidth <= 767"><img src="~@/assets/images/play-intro-img-m-3.png" /></div>
                      <h4 class="marginTop15">Goals Over/Under Result Prediction:</h4>
                      <p>Displays whether the result of the number of goals scored in the full-time match is "Over" or "Under".</p>
                    </div>
                  </div>
                  <div class="intro-play-item marginTop10">
                    <div class="intro-play-img" v-if="screenWidth > 767"><img src="~@/assets/images/play-intro-img-3.png" /></div>
                    <div class="intro-play-info">
                      <div class="intro-play-img" v-if="screenWidth <= 767"><img src="~@/assets/images/play-intro-img-m-4.png" /></div>
                      <h4>Correct Scores Result Prediction:</h4>
                      <p>Displays the 3 most probable final scores after 90 minutes of play.</p>
                      <div class="intro-play-img" v-if="screenWidth <= 767"><img src="~@/assets/images/play-intro-img-m-5.png" /></div>
                      <h4 class="marginTop15">Goals Result Prediction:</h4>
                      <p>Displays the 2 most probable total goal counts after 90 minutes of play as predicted.</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </van-popup>
  </div>
</template>
<script>
  import { Toast } from 'vant';
  import PredictionList from './homePredictionList.vue';

	export default {
    name: 'predictionMatch',
    components: {
      PredictionList,
    },
    
    props: {
      setting: {
        type: Object,
        default: () => {}
      },
      listDataPro: {
        type: Object,
        default: () => {}
      },
      svrTimestamp: {
        type: Number,
        default: () => 0
      },
    },

		data(){
			return{
        macthTipsShow: false,

        screenWidth:2000,
      }
		},

    computed: {
      
    },

    mounted(){
      this.screenWidth = window.innerWidth;
      window.addEventListener('resize', this.handleResize);
    },

		methods:{
      // google事件点击统计
      googleEventClick(){
        let eventName = 'LS_PC_H_Predictions_More_Click';
        if(this.common.isMobile != 4){
            eventName = 'LS_Webapp_H_Predictions_More_Click';
        }
        this.common.googleEvent(eventName);
      },
      // 是否显示弹窗
      matchTipsIsShow(){
        if(!this.macthTipsShow){
          let eventName = 'LS_PC_Help_Click';
          if(this.common.isMobile != 4){
              eventName = 'LS_Webapp_Help_Click';
          }

          this.common.googleEvent(eventName, {
              '点击位置': '首页-预测比赛'
          });
        }

        this.macthTipsShow = !this.macthTipsShow;
      },

      //获取屏幕宽度
      handleResize() {
        if(typeof window!='undefined'){
          this.screenWidth = window.innerWidth;
        }
      },
		},

		created(){
      
		},

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },

    destroyed() {
      
    },
    // watch: {
    //   'listDataPro': {
    //     immediate: true,
    //     deep: true,
    //     handler(val){
    //       if(this.$refs.predListFn){
    //         this.$refs.predListFn.setTodays();
    //       }
    //     }
    //   },
    // }
	};

</script>
<style lang="less" scoped>
@import '~@/style/index/homePrediction.less';
</style>


// WEBPACK FOOTER //
// ./src/views/home/components/homePredictionMatch.vue